<template>
  <section id="prompt">
    <FirstRun v-bind:sharedResponse="sharedReponse" v-bind:user="user"></FirstRun>

    <div id="promptContent">
      <div v-if="isLoaded == false">
        <h1>Loading ...</h1>
      </div>
      <div v-else>
        <div class="promptText">
          <h3>Prompt:</h3>
          <p>{{ currentPrompt.prompt }}</p>
        </div>

        <h3>The response:</h3>
        <p class="promptText">{{responseForPrompt.response}}</p>

        <div class="share" v-if="!$route.query.gen">
          <p><router-link class="btnLink" :to="{ name: 'Prompt', params: {pid: currentPrompt.id} }">Write your own response ›</router-link></p>
        </div>

      </div>
    </div>
  </section>
</template>

<script type="text/javascript">
  import api from "../services/DataService";
  import FirstRun from "../components/FirstRun"

  export default {
    props: ['user'],
    data: function () {
      return {
        prompts: [],
        seePrompt: false,
        seeForm: false,
        responseSubmitted: false,
        countDownVal: 0,
        timerRunning: false,
        responseForPrompt: {},
        isLoaded: false,
        emailAddress: "",
        responseEmailed: false,
        timerExpired: false,
        currentPrompt: {},
        sharedReponse: true
      }
    },
    components: { FirstRun },
    mounted: function() {
      this.fetchData();
    },
    computed: {
      rid: function () {
        let r = this.$route.params.rid;
        if (r) return r;
        else return false;
      }
    },
    watch: {
      '$route': 'fetchData'
    },
    methods: {
      fetchData () {
        this.isLoaded = false;

        if (this.$route.query.gen) {
          api.getGenResponse(this.rid)
            .then(response => {
              this.responseForPrompt.response = response.data.data.response;
              this.currentPrompt.prompt = response.data.data.prompt;
              this.isLoaded = true;
            })
            .catch(e => {
              console.log(e);
            });
        } else {
          api.getResponse(this.rid)
            .then(response => {
              this.responseForPrompt = response.data.data;
              // get prompt text for this response
              api.getPrompt(this.responseForPrompt.prompt_id)
                .then(response => {
                  if (response.data.data) {
                    this.currentPrompt = response.data.data;
                  }
                  this.isLoaded = true;
                })
                .catch(e => {
                  console.log(e);
                });
            })
            .catch(e => {
              console.log(e);
            });
        }
      }
    }
  }
</script>

<style media="screen" src="../styles/prompt.css"></style>
